/**
 * Возвращает тип и класс перелёта из данных о перелёте
 */
import { FLIGHT_CLASSES, FLIGHT_CLASSES_NAME, FLIGHT_TYPES_NAME } from './constants';
import { FlightType } from '@lt/api/dist/methods/packages/types';

type Params = {
  type: FlightType;
  warning?: boolean;
  business: boolean;
  [k: string]: unknown;
};

// TODO: выпилить warning, когда от всех туроператоров будет приходить поле type
// https://leveltravel.atlassian.net/browse/LT-11385
export const getFlightTypeData = ({
  type,
  warning: isRegular,
  business: isBusinessClass,
}: Params) => ({
  flightType: type || (isRegular ? FLIGHT_TYPES_NAME.REGULAR : FLIGHT_TYPES_NAME.CHARTER),
  flightClass: isBusinessClass
    ? FLIGHT_CLASSES_NAME[FLIGHT_CLASSES.BUSINESS]
    : FLIGHT_CLASSES_NAME[FLIGHT_CLASSES.ECONOMY],
});
